/**
 * Decoded size of a base64 payload without decoding it: 3 bytes per 4
 * characters, minus the trailing `=` padding. Used to budget email
 * attachments on both sides of the wire.
 */
export function base64DecodedBytes(contentBytes: string): number {
  const trimmed = contentBytes.trim();
  if (trimmed.length === 0) return 0;
  const padding = trimmed.endsWith("==") ? 2 : trimmed.endsWith("=") ? 1 : 0;
  return Math.floor((trimmed.length * 3) / 4) - padding;
}
